<template>


  <div class="ovningar-container" >

<div class="arkrad">

      <div class="inlajn" v-for="(item,index) in this.$router.options.routes" :key="item.path">


          <div class="inlajn" v-if="item.props && item.props.uppgifter && (item.props.synligVid <= steg)" >
              <router-link   :id="index" class="nolinkstyle miniark-container" :to="item"
              v-bind:style="[(item.props.svartVid > steg) ? {'color':'brown'} : {'color':'black'}]">
                  <div class="miniark" v-bind:style="{ backgroundColor : (gronStapel[item.props.avsnitt]=='100%') ? '#ccfcc0' : 'white' }">



                      <div class="miniark-inner-container" >
                          <p>{{item.props.title}}</p>

                          <div v-bind:style="{ width: gronStapel[item.props.avsnitt]}" class="gron-stapel"></div>
                          <div v-bind:style="{ width: blaStapel[item.props.avsnitt]}" class="bla-stapel"></div>
                      </div>



                  </div>
              </router-link>
          </div>


          <div class="inlajn" v-if="item.rubrik && (item.synligVid <= steg)">
              <div class="rubrikcontainer"><h2 class="lokal-h2">{{item.rubrik}}</h2></div>
          </div>

          <div class="inlajn" v-if="item.radbryt">
              <br>
          </div>


      </div>
</div>



  </div>
</template>

<script>
export default {
  name: 'B',
  title () {
    return `Övningar | Tysk Grammatik`
  },
  props: {

    msg: String
},
data() {
    return {
       message: 'Old message!',
       shortRoute: Object,
       totLangd: [],
       totGjorda: [],
       totRatta: [],
       gronStapel: [],
       blaStapel: [],
       steg: 0,

    }
},
methods: {
    vilkenSynlig: function() {
        var kk = window.document.done["Steg"];
        if (kk == "") {
            kk=6;
        }
        this.steg=kk;
    },

},
beforeMount() {


    this.shortRoute=this.$router.options.routes;

        var that=this
        this.shortRoute.forEach(function(element) {
            if(typeof element.props !== 'undefined') {

                that.totLangd[element.props.avsnitt] = element.props.uppgifter.length;

                that.totGjorda[element.props.avsnitt] = 0;
                that.totRatta[element.props.avsnitt] = 0;
                for(var j=0; j < that.totLangd[element.props.avsnitt]; j++) {
                    /*Hur många övningar har skrivits något på*/
                    if(window.document.done[element.props.avsnitt]['dittSvar'][j]) {
                        that.totGjorda[element.props.avsnitt]++;
                    }
                    /*Hur många rätt har du*/
                    if(window.document.done[element.props.avsnitt]['dinRattning'][j] ==="rätt") {
                        that.totRatta[element.props.avsnitt]++;
                    }
                }
                that.gronStapel[element.props.avsnitt]=(Math.round(100*(that.totRatta[element.props.avsnitt]/that.totLangd[element.props.avsnitt]))+"%");
                that.blaStapel[element.props.avsnitt]=(Math.round(100*(that.totGjorda[element.props.avsnitt]/that.totLangd[element.props.avsnitt]))+"%");
            }
        });


},
mounted() {
    this.$root.$on('myEvent', (text) => { // here you need to use the arrow functi on
     this.message = text;
     this.vilkenSynlig();
    })
    this.vilkenSynlig();

},
updated() {
    this.vilkenSynlig();
}
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.miniark-container {
    position: relative;
    /*height: 264px;
    width: 176px;*/
    height: 211px;
    width: 141px;
    display: inline-block;
}


.miniark-container {
    position: relative;
    /*height: 264px;
    width: 176px;*/
    height: 211px;
    width: 141px;
    display: inline-block;
}



.arkrad {
    width:70%;
    margin:auto;
    margin-bottom: 2em;
}
@media (max-width:804px) {
    .arkrad {
        width:100%;
    }
}


/* Safari 4.0 - 8.0 */
@-webkit-keyframes mjukframkomst {
  from {
      opacity: 0;
  }
  to {
      opacity: 1;
  }
}

/* Standard syntax */
@keyframes mjukframkomst {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.ovningar-container {
    -webkit-animation: mjukframkomst 1s; /* Safari 4.0 - 8.0 */
    animation: mjukframkomst 1s;
}

.miniark {
    position: absolute;
    bottom: 0;
    left: 8px;
    background-color: white;
    /*height: 240px;
    width:160px;*/
    width: 128px;
    height: 192px;
    box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
    display: inline-block;

    /*-webkit-animation: mjukframkomst 1s; /* Safari 4.0 - 8.0 */
    /*animation: mjukframkomst 1s;*/

    overflow: hidden;
    /*padding-left:3px;
    padding-right:3px;*/
    box-sizing: border-box;
    transition: font-size .3s linear, height .3s linear, width .3s linear, left .3s linear;
}

.miniark-inner-container {
    position: relative;

    height: 100%;
}

/*.miniark > p {
    margin-left: 3px;
    margin-right: 3px;

}*/

.miniark-inner-container > p {
    margin-left: 3px;
    margin-right: 3px;

}

.miniark:hover {
    /*font-size: 1.4em;
    left: 0;
    width: 176px;
    height: 264px;
    transition: .3s;
    z-index: 10;*/

    font-size: 1.1em;
    left: 0;
    width: 140.5px;
    height: 211px;
    transition: .3s;
    z-index: 10;

}


p {
    margin-top:0.3em;
    font-family: serif;
    font-size: 1.3em;
    /*color: black;*/
}

.nolinkstyle {
    text-decoration: none;
    /*color: black;*/
}



.lokal-h2 {
    background-color: white;
    display: inline-block;
    padding:2px 0 2px 0;
    border-radius: 2px;
    /*width: 160px;*/
    width: 550px;
    color: black;
    background: rgba(255, 255, 255, 0.8);
    font-family: sans-serif;
    color: #2c3e50;
}

@media (max-width:550px) {
    .lokal-h2 {
        width: 100%;
    }

}


.rubrikcontainer {
    /*display: block;*/
    margin-bottom: 0em;
    margin-top: 2em;

}


.miniark-container {
    /*display: none;*/
}

.rod {
    /*display: inline-block;*/
    color: brown;
}

.svart {
    display: inline-block;
    color: black;
}

.disp-block {
    display: block;
}



.gron-stapel {
    position: absolute;
    display: block;
    background-color: green;
    height: 3px;
    /*bottom: 8px;*/
    bottom: 4.7%;
    width: 0;
}




.bla-stapel {
    position: absolute;
    display: block;
    background-color: black;
    height: 3px;
    /*bottom: 4px;*/
    bottom: 3.2%;
    width: 0;
}

</style>
